module.exports = __webpack_public_path__ + "assets/img/g1.1799a1da.png";